import { FormSelectProps } from 'components/FormSelect';
import { LabelFieldEnum, LabelFieldsItemType, UploadIDProps } from '../UploadID';
import { PicExemptionEnum } from './type';

export const chnExemptionTypeOptions: FormSelectProps['options'] = [
    {
        value: PicExemptionEnum.OTHER_BROKER_PROOF,
        label: __('其他境外券商账户证明')
    }
];

const uploadDescriptionOptions: Record<PicExemptionEnum, Partial<LabelFieldsItemType>> = {
    [PicExemptionEnum.OTHER_BROKER_PROOF]: {
        label: __('请您上传其他境外券商账户证明'),
        desc: {
            needOrderNum: false,
            texts: [
                __(
                    '应中国证监会要求，中国大陆投资者必须提供已在另一家境外券商开立经纪账户的证明。其他境外券商账户证明可以使用账单证明或者开户证明，所提供文件需显示以下信息：'
                ),
                `1. ${__('客户姓名（中文或英文）')}`,
                `2. ${__('券商名称')}`,
                `3. ${__('账号')}`,
                `4. ${__('账单或开户时间（需在2023年5月19日前）')}`
            ]
        }
    }
};

/**
 * @description 获取uploadId的自定义的extraLabelFields
 * @param uploadFiles 传给UploadId组件的uploadFiles参数
 * @param formPicExemptionType 表单中的豁免证明类型
 */
export function getExtraLabelFields(
    uploadFiles: LabelFieldEnum[],
    formPicExemptionType: PicExemptionEnum | ''
): UploadIDProps['extraLabelFields'] {
    if (formPicExemptionType) {
        return uploadFiles.reduce((prev, cur) => {
            prev[cur] = uploadDescriptionOptions[formPicExemptionType];

            return prev;
        }, {});
    }

    return undefined;
}
